import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { DrawingDefaultFolderFilesResponse } from "../../../Controllers/Types/Project/ProjectResponse";
import { baseURL } from "../../ApiConstant";


export const drawingCollectionGetDataAPI = async (subFolderId: number): Promise<DrawingDefaultFolderFilesResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/sub-folder-drawing-collection/${subFolderId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data['data'] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const FolderdrawingCollectionGetDataAPI = async (folderId: number): Promise<DrawingDefaultFolderFilesResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/folder-drawing-collection/${folderId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data['data'] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const drawingCollectionCreateAPI = async (forCreate: string, folder_id: number | null, sub_folder_id: number | null, drawing_type_id: number, drawing_name: string, path: File[]): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('for', forCreate);
        if (folder_id) {
            formData.append('folder_id', String(folder_id));
        }
        if (sub_folder_id) {
            formData.append('sub_folder_id', String(sub_folder_id));
        }
        formData.append('drawing_type_id', String(drawing_type_id));
        formData.append('drawing_name', drawing_name);
        if (path) {
            path.forEach((file, index) => {
                formData.append('path[]', file);
            });
        }

        const response = await fetch(`${baseURL}/api/sub-folder-drawing-collection/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });


        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const drawingCollectionUpdateAPI = async (drawingCollectionId: number, drawing_type_id: number, drawing_name: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('drawing_type_id', String(drawing_type_id));
        formData.append('drawing_name', drawing_name);
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/sub-folder-drawing-collection/update/${drawingCollectionId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });


        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const drawingCollectionDeleteAPI = async (drawingCollectionId: number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/sub-folder-drawing-collection/delete/${drawingCollectionId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });


        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};